<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <el-select
                v-model="newLocation"
                placeholder="Standort wählen"
                @change="updateGlobalLocation"
                :disabled="role < 3"
                v-if="multiLocationMode == 1"
              >
              <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
        </el-select>
    </div>

    <template slot="navbar-menu">
      <li class="nav-item pl-3 mt-2 mr-4">
          <p>
            <span class=""><b>Angemeldeter Benutzer:</b> {{ displayName }}</span>
          </p>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="showFeedback"
          style="cursor: pointer"
        >
          <i
            class="bi bi-chat-left-heart mr-1"
            style="font-size: 1.2rem"
            title="Feedback zur Arbeit im Kletterwald"
          ></i>
          <p>
            <span class="d-md-block"> Feedback</span>
          </p>
        </a>
      </li>
      <li class="nav-item" v-if="role > 0">
        <a
          class="nav-link"
          @click.prevent="showUserSettings"
          style="cursor: pointer"
        >
          <i
            class="bi bi-person"
            style="font-size: 1.2rem"
            title="Passwort ändern"
          ></i>
          <p>
            <span class="d-lg-none d-md-block">Passwort ändern</span>
          </p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="showHelp" style="cursor: pointer">
          <i
            class="bi bi-question-circle"
            style="font-size: 1.2rem"
            title="Hilfe"
          ></i>
          <p>
            <span class="d-lg-none d-md-block"> Hilfe</span>
          </p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="signOut" style="cursor: pointer">
          <i
            class="bi bi-box-arrow-right"
            style="font-size: 1.2rem"
            title="Abmelden"
          ></i>
          <p>
            <span class="d-lg-none d-md-block"> Abmelden</span>
          </p>
        </a>
      </li>
    </template>
    <modal :show.sync="modals.help" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Hilfe</h5>
      <div class="row">
        <div class="col">
          <p>
            Bei Fragen, Problemen oder Anregungen melde dich gerne per E-Mail oder per WhatsApp:
          </p>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col mr-4 ml-4">
          <a href="mailto:info@verti-hub.com" target="_blank" style="text-decoration: none;">
            <p-button size="lg" type="success" block><i class="bi bi-envelope-at"></i> Mail an info@verti-hub.com senden</p-button>
          </a>
        </div>
      </div>
      <div class="row pb-3">
        <div class="col mr-4 ml-4">
          <a href="https://wa.me/4915155563719" target="_blank" style="text-decoration: none;">
            <p-button size="lg" type="success" block><i class="bi bi-whatsapp"></i> Nachricht per WhatsApp senden</p-button>
          </a>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col">
          <span class="text-muted"><i><b>VertiHub Version:</b> {{ version }}</i></span>
        </div>
      </div>
      <template slot="footer">
          <p-button
            type="default"
            link
            @click="
              modals.help = false;
            "
            >Schließen</p-button
          >
      </template>
    </modal>
    <modal :show.sync="modals.feedback" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Feedback Kletterwald</h5>
      <div class="row">
        <div class="col">
          <p>
            Feedback zur Arbeit im Kletterwald? Nutze gerne das folgende Feld um deine Rückmeldung dem Team der Parkleitung zukommen zu lassen. Dein Feedback ist anonym und nur für die Parkleitung zugänglich.
          </p>
        </div>
      </div>
      <div class="row pt-3 pb-3">
        <div class="col">
          <textarea
            class="form-control px-2"
            placeholder="Dein Feedback..."
            rows="7"
            v-model="newFeedback"
          ></textarea>
        </div>
      </div>
      <div class="row pt-3 pb-3" v-if="multiLocationMode == 1">
        <div class="col">
          <label>Auf welchen Standort bezieht sich dein Feedback?</label>
          <el-select
                  v-model="newFeedbackLocation"
                  placeholder="Standort wählen"
                >
                <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
          </el-select>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button
            type="default"
            link
            @click="
              modals.feedback = false;
              newFeedback = '';
            "
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveFeedback"
            >Senden</p-button
          >
        </div>
      </template>
    </modal>
    <modal
      :show.sync="modals.changePassword"
      headerClasses="justify-content-center"
    >
      <h5 slot="header" class="title mb-0">Passwort ändern</h5>
      <div class="row">
        <div class="col">
          <p>
            Das neue Passwort muss 8-20 Zeichen lang sein und
            Groß-/Kleinbuchstaben, Zahlen sowie Sonderzeichen enthalten.
          </p>
        </div>
      </div>
      <div class="row pt-4">
        <div class="col">
          <fg-input
            placeholder="Aktuelles Passwort"
            label="Aktuelles Passwort"
            type="password"
            class="col-8"
            v-model="currentPassword"
          ></fg-input>
        </div> 
      </div>
      <div class="row pt-3">
        <div class="col">
          <fg-input
            placeholder="Neues Passwort"
            label="Neues Passwort"
            type="password"
            class="col-8"
            v-model="newPassword"
          ></fg-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col">
          <fg-input
            placeholder="Neues Passwort wiederholen"
            label="Neues Passwort wiederholen"
            type="password"
            class="col-8"
            v-model="newPasswordRepeat"
          ></fg-input>
        </div>
      </div>
      <div class="row pt-4">
        <div class="col">
          <div
            class="alert alert-danger"
            role="alert"
            v-if="passwordFormValidationErrors.length > 0"
          >
            <b>Bitte die folgenden Fehler beheben:</b>
            <ul>
              <li v-for="error in passwordFormValidationErrors" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button
            type="default"
            link
            @click="
              modals.changePassword = false;
              newPassword = '';
              newPasswordRepeat = '';
              currentPassword = '';
            "
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="changePassword"
            >Passwort ändern</p-button
          >
        </div>
      </template>
    </modal>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components/UIComponents";
import { provider, db, firebaseApp, fc } from "../../../firebaseDb";
import store from "../../../store";
import { Modal } from "src/components/UIComponents";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { Select, Option } from "element-ui";
import { httpsCallable } from "firebase/functions";
import router from "../../../main";
import locations from "../../../locationStore";

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      displayName: store.getters.user.data.displayName,
      username: store.getters.user.data.email,
      role: store.getters.userrole,
      psaRole: store.getters.psaRole,
      constructionRole: store.getters.constructionRole,
      retterpruefungRole: store.getters.retterpruefungRole,
      modals: {
        feedback: false,
        changePassword: false,
        help: false,
      },
      newFeedback: "",
      newFeedbackLocation: "",
      passwordFormValidationErrors: [],
      newPassword: null,
      newPasswordRepeat: null,
      currentPassword: null,
      newLocation: store.getters.userlocation,
      uid: "",
      multiLocationMode: process.env.VUE_APP_MULTIPLE_LOCATIONS,
      locations: locations.getters.locations.locations,
      version: store.getters.appVersion,
    };
  },
  methods: {
    updateGlobalLocation() {
      // Optimistic update: change the active location in the Vuex store immediately
      // so the UI reacts without waiting for the round-trip to the Cloud Function in
      // europe-west3. The custom-claim update only matters for persistence across
      // sessions (read at app boot from the auth token), so it can run in the
      // background.
      const previousLocation = store.getters.userlocation;
      const targetLocation = this.newLocation;
      store.commit('SET_USERLOCATION', targetLocation);
      this.$notify({
        message: 'Standort wurde geändert!',
        icon: 'fa fa-check-circle',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success',
        showClose: true,
        timeout: 3000
      });

      const changeLocation = httpsCallable(fc, "users-changeUserLocation");
      changeLocation({
        uid: this.uid,
        location: targetLocation,
        role: this.role,
        psaRole: this.psaRole,
        constructionRole: this.constructionRole,
        retterpruefungRole: this.retterpruefungRole,
      }).catch((err) => {
        console.error('changeUserLocation failed', err);
        // Revert UI + dropdown selection if the persistence call failed.
        store.commit('SET_USERLOCATION', previousLocation);
        this.newLocation = previousLocation;
        this.$notify({
          message: 'Standort konnte nicht dauerhaft gespeichert werden.',
          icon: 'fa fa-exclamation-triangle',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger',
          showClose: true,
          timeout: 5000
        });
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    signOut() {
      firebaseApp
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "Login",
          });
        });
    },
    showFeedback() {
      this.modals.feedback = true;
    },
    showUserSettings() {
      this.modals.changePassword = true;
    },
    showHelp() {
      this.modals.help = true;
    },
    saveFeedback() {
      if (this.newFeedback) {
        db.collection("feedback")
          .add({
            text: this.newFeedback,
            user: this.displayName,
            timestamp: new Date(),
            location: this.newFeedbackLocation,
          })
          .then(() => {
            this.modals.feedback = false;
            this.newFeedback = "";
            this.$notify({
              message: 'Feedback wurde erfolgreich gesendet!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch(() => {
            console.log("Adding Feedback failed");
          });
      } else {
        this.modals.feedback = false;
      }
    },
    changePassword() {
      this.passwordFormValidationErrors = [];
      if (this.newPassword !== this.newPasswordRepeat) {
        this.passwordFormValidationErrors.push(
          "Die eingebenen Passwörter sind nicht identisch."
        );
      }
      if (this.newPassword.length < 8) {
        this.passwordFormValidationErrors.push(
          "Das Passwort ist nicht ausreichend lang (mind. 8 Zeichen)."
        );
      }
      if (this.newPassword.length > 20) {
        this.passwordFormValidationErrors.push(
          "Das Passwort ist zu lang (max. 20 Zeichen)"
        );
      }
      if (!this.newPassword.match(/[a-z]+/)) {
        this.passwordFormValidationErrors.push(
          "Das Passwort enthält keine Kleinbuchstaben."
        );
      }
      if (!this.newPassword.match(/[A-Z]+/)) {
        this.passwordFormValidationErrors.push(
          "Das Passwort enthält keine Großbuchstaben."
        );
      }
      if (!this.newPassword.match(/[0-9]+/)) {
        this.passwordFormValidationErrors.push(
          "Das Passwort enthält keine Ziffern."
        );
      }
      if (!this.newPassword.match(/[$@$!%*?&+-.,]+/)) {
        this.passwordFormValidationErrors.push(
          "Das Passwort enthält keine Sonderzeichen"
        );
      }
      if (this.passwordFormValidationErrors.length < 1) {
        const user = firebaseApp.auth().currentUser;
        user
          .updatePassword(this.newPassword)
          .then(() => {
            this.$notify({
              message: "Das Passwort wurde erfolgreich geändert!",
              icon: "fa fa-check-circle",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "success",
              showClose: true,
              timeout: 5000,
            });
            this.newPassword = null;
            this.newPasswordRepeat = null;
            this.modals.changePassword = false;
          })
          .catch((error) => {
            if (error.code === "auth/requires-recent-login") {
              const cred = firebase.auth.EmailAuthProvider.credential(
                this.username,
                this.currentPassword
              );
              user
                .reauthenticateWithCredential(cred)
                .then(() => {
                  user.updatePassword(this.newPassword).then(() => {
                    this.$notify({
                      message: "Das Passwort wurde erfolgreich geändert!",
                      icon: "fa fa-check-circle",
                      horizontalAlign: "right",
                      verticalAlign: "bottom",
                      type: "success",
                      showClose: true,
                      timeout: 5000,
                    });
                    this.newPassword = null;
                    this.newPasswordRepeat = null;
                    this.currentPassword = null;
                    this.modals.changePassword = false;
                  });
                })
                .catch(() => {
                  this.$notify({
                    message: "Die Passwortänderung ist fehlgeschlagen!",
                    icon: "fa fa-triangle-exclamation",
                    horizontalAlign: "right",
                    verticalAlign: "bottom",
                    type: "warning",
                    showClose: true,
                    timeout: 5000,
                  });
                  this.newPassword = null;
                  this.newPasswordRepeat = null;
                  this.currentPassword = null;
                  this.modals.changePassword = false;
                });
            } else {
              this.$notify({
                message: "Die Passwortänderung ist fehlgeschlagen!",
                icon: "fa fa-triangle-exclamation", 
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: "warning",
                showClose: true,
                timeout: 5000,
              });
              this.newPassword = null;
              this.newPasswordRepeat = null;
              this.currentPassword = null;
              this.modals.changePassword = false;
            }
            console.log(error);
          });
      }
    },
  },
  created() {
    firebaseApp.auth().currentUser.getIdTokenResult(true).then((tokenResult) => {
      this.role = tokenResult.claims.role;
      this.psaRole = tokenResult.claims.psaRole;
      this.constructionRole = tokenResult.claims.constructionRole;
      this.retterpruefungRole = tokenResult.claims.retterpruefungRole;
      this.uid = firebaseApp.auth().currentUser.uid;
      this.newLocation = tokenResult.claims.location
    });
  },
};
</script>
<style>
</style>
